import React from 'react';
import PropTypes from 'prop-types';

function lazy(name) {
  return React.lazy(() => import(`@strava/icons/${name}`));
}

const activities = {
  alpineski: {
    small: lazy('SportsSkiNormalSmall'),
    xsmall: lazy('SportsSkiNormalXsmall')
  },
  backcountryski: {
    small: lazy('SportsSkiNormalSmall'),
    xsmall: lazy('SportsSkiNormalXsmall')
  },
  canoeing: {
    small: lazy('SportsKayakingNormalSmall'),
    xsmall: lazy('SportsKayakingNormalXsmall')
  },
  crossfit: {
    small: lazy('SportsWeightTrainingNormalSmall'),
    xsmall: lazy('SportsWeightTrainingNormalXsmall')
  },
  ebikeride: {
    small: lazy('SportsEBikeRideNormalSmall'),
    xsmall: lazy('SportsEBikeRideNormalXsmall')
  },
  elliptical: {
    small: lazy('SportsOtherNormalSmall'),
    xsmall: lazy('SportsOtherNormalXsmall')
  },
  golf: {
    small: lazy('SportsOtherNormalSmall'),
    xsmall: lazy('SportsOtherNormalXsmall')
  },
  handcycle: {
    small: lazy('SportsHandcycleNormalSmall'),
    xsmall: lazy('SportsHandcycleNormalXsmall')
  },
  hike: {
    small: lazy('SportsHikeNormalSmall'),
    xsmall: lazy('SportsHikeNormalXsmall')
  },
  iceskate: {
    small: lazy('SportsIceSkateNormalSmall'),
    xsmall: lazy('SportsIceSkateNormalXsmall')
  },
  inlineskate: {
    small: lazy('SportsInlineSkateNormalSmall'),
    xsmall: lazy('SportsInlineSkateNormalXsmall')
  },
  kayaking: {
    small: lazy('SportsKayakingNormalSmall'),
    xsmall: lazy('SportsKayakingNormalXsmall')
  },
  kitesurf: {
    small: lazy('SportsKitesurfNormalSmall'),
    xsmall: lazy('SportsKitesurfNormalXsmall')
  },
  nordicski: {
    small: lazy('SportsSkiNormalSmall'),
    xsmall: lazy('SportsSkiNormalXsmall')
  },
  ride: {
    small: lazy('SportsBikeNormalSmall'),
    xsmall: lazy('SportsBikeNormalXsmall')
  },
  rockclimbing: {
    small: lazy('SportsRockClimbingNormalSmall'),
    xsmall: lazy('SportsRockClimbingNormalXsmall')
  },
  rollerski: {
    small: lazy('SportsSkiNormalSmall'),
    xsmall: lazy('SportsSkiNormalXsmall')
  },
  rowing: {
    small: lazy('SportsRowingNormalSmall'),
    xsmall: lazy('SportsRowingNormalXsmall')
  },
  run: {
    small: lazy('SportsRunNormalSmall'),
    xsmall: lazy('SportsRunNormalXsmall')
  },
  sail: {
    small: lazy('SportsWaterNormalSmall'),
    xsmall: lazy('SportsWaterNormalXsmall')
  },
  skateboard: {
    small: lazy('SportsOtherNormalSmall'),
    xsmall: lazy('SportsOtherNormalXsmall')
  },
  snowboard: {
    small: lazy('SportsSnowboardNormalSmall'),
    xsmall: lazy('SportsSnowboardNormalXsmall')
  },
  snowshoe: {
    small: lazy('SportsSnowshoeNormalSmall'),
    xsmall: lazy('SportsSnowshoeNormalXsmall')
  },
  soccer: {
    small: lazy('SportsOtherNormalSmall'),
    xsmall: lazy('SportsOtherNormalXsmall')
  },
  stairstepper: {
    small: lazy('SportsRunNormalSmall'),
    xsmall: lazy('SportsRunNormalXsmall')
  },
  standuppaddling: {
    small: lazy('SportsStandUpPaddlingNormalSmall'),
    xsmall: lazy('SportsStandUpPaddlingNormalXsmall')
  },
  surfing: {
    small: lazy('SportsSurfingNormalSmall'),
    xsmall: lazy('SportsSurfingNormalXsmall')
  },
  swim: {
    small: lazy('SportsWaterNormalSmall'),
    xsmall: lazy('SportsWaterNormalXsmall')
  },
  velomobile: {
    small: lazy('SportsVelomobileNormalSmall'),
    xsmall: lazy('SportsVelomobileNormalXsmall')
  },
  virtualride: {
    small: lazy('SportsBikeNormalSmall'),
    xsmall: lazy('SportsBikeNormalXsmall')
  },
  virtualrun: {
    small: lazy('SportsRunNormalSmall'),
    xsmall: lazy('SportsRunNormalXsmall')
  },
  walk: {
    small: lazy('SportsWalkNormalSmall'),
    xsmall: lazy('SportsWalkNormalXsmall')
  },
  watersport: {
    small: lazy('SportsWaterNormalSmall'),
    xsmall: lazy('SportsWaterNormalXsmall')
  },
  weighttraining: {
    small: lazy('SportsWeightTrainingNormalSmall'),
    xsmall: lazy('SportsWeightTrainingNormalXsmall')
  },
  wheelchair: {
    small: lazy('SportsWheelchairNormalSmall'),
    xsmall: lazy('SportsWheelchairNormalXsmall')
  },
  windsurf: {
    small: lazy('SportsWindsurfNormalSmall'),
    xsmall: lazy('SportsWindsurfNormalXsmall')
  },
  wintersport: {
    small: lazy('SportsSnowNormalSmall'),
    xsmall: lazy('SportsSnowNormalXsmall')
  },
  workout: {
    small: lazy('SportsOtherNormalSmall'),
    xsmall: lazy('SportsOtherNormalXsmall')
  },
  yoga: {
    small: lazy('SportsYogaNormalSmall'),
    xsmall: lazy('SportsYogaNormalXsmall')
  }
};

const ActivityIcon = ({ type, size, ...props }) => {
  const SportType =
    activities[type.toLowerCase()][size.toLowerCase()] ||
    activities.workout[size.toLowerCase()];

  if (SportType) {
    return (
      <React.Suspense fallback={<div />}>
        {React.createElement(SportType, { ...props })}
      </React.Suspense>
    );
  }

  return null;
};

ActivityIcon.propTypes = {
  type: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['xsmall', 'Xsmall', 'small', 'Small']).isRequired
};

export default ActivityIcon;
